// One vendor's membership on an order, and a balance read off it.
//
// The snapshot is keyed by vendor, so this is a key access rather than a
// search. It exists as a module anyway because the "unknown is not zero" rule
// below is the part worth having in one place and testing.
//
// NULL MEANS "WE DO NOT KNOW", AND IT IS NOT ZERO. Two different situations
// both land here -- this customer is not a member of that platform, and the
// platform did not answer -- and neither is "they have nothing to spend". A
// cashier told `0` says exactly that to the customer, so both stay null and the
// field shows a dash.

// The membership for that vendor, or null.
function memberOf(doc, vendor) {
  const consumer = doc ? doc.consumer : null
  const members = consumer ? consumer.members : null

  if (!members || !vendor) return null

  return members[vendor] || null
}

// `points` or `credits` for that vendor. Null for anything we cannot state.
function balanceOf(doc, vendor, field) {
  const member = memberOf(doc, vendor)
  if (!member) return null

  const value = member[field]

  return value === undefined || value === null || value === '' ? null : value
}

// WHO WOULD BE CREDITED, and so whether an award for this vendor is possible at
// all. Null means it is not: memberFromForm answers null without one, so
// awardIntake stores nothing, and an award that somehow reached the sweep
// without one is refused as `unusable member`.
//
// NOT THE SAME QUESTION AS `balanceOf`. A member whose balances the platform
// would not report still has an id, and a 折抵 against them settles perfectly
// well -- the staff is taking the customer's word for the balance, which is
// their call to make. A missing id is the case where nothing can settle.
function vendorIdOf(doc, vendor) {
  const member = memberOf(doc, vendor)
  if (!member) return null

  const value = member.vendorId

  return value === undefined || value === null || value === '' ? null : value
}

export { memberOf, balanceOf, vendorIdOf }
